import React from 'react'

const Icon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M9.99984 10.7115L7.28838 8.00008L8.06234 7.24216L9.45817 8.638V5.78862H10.5415V8.638L11.9373 7.24216L12.7113 8.00008L9.99984 10.7115ZM3.4165 16.5834V3.41675H16.5832V16.5834H3.4165ZM4.49984 15.5001H15.4998V12.3399H12.9261C12.6601 12.9371 12.2646 13.4197 11.7394 13.7878C11.2143 14.1558 10.6344 14.3399 9.99984 14.3399C9.35137 14.3399 8.76456 14.1593 8.23942 13.7982C7.71428 13.4371 7.32567 12.951 7.07359 12.3399H4.49984V15.5001ZM9.99984 13.2565C10.5554 13.2565 11.0276 13.0621 11.4165 12.6732C11.8054 12.2843 11.9998 11.8121 11.9998 11.2565H15.4998V4.50008H4.49984V11.2565H7.99984C7.99984 11.8121 8.19428 12.2843 8.58317 12.6732C8.97206 13.0621 9.44428 13.2565 9.99984 13.2565Z'
        fill='white'
      />
    </svg>
  )
}

export default Icon
